export enum StatsEmitterEvent {
  pageView = 'page-view',
  homePage = 'home-page',
  propertyPage = 'property-page',
  propertySerp = 'property-serp',
  propertyImpression = 'property-impression',
  propertyLoad = 'property-load',
  propertyLeadClick = 'property-lead-click',
  propertyLeadSend = 'property-lead-send',
  propertyClick = 'property-click',
  propertySave = 'property-save',
  propertyUnsave = 'property-unsave',
  propertyImageBrowse = 'property-image-browse',
  agentHome = 'agent-home',
  agentPage = 'agent-page',
  agentSerp = 'agent-serp',
  agentImpression = 'agent-impression',
  agentLoad = 'agent-load',
  agentLeadClick = 'agent-lead-click',
  agentLeadSend = 'agent-lead-send',
  agentClick = 'agent-click',
  brokerHome = 'broker-home',
  brokerPage = 'broker-page',
  brokerSerp = 'broker-serp',
  brokerImpression = 'broker-impression',
  brokerLoad = 'broker-load',
  brokerLeadClick = 'broker-lead-click',
  brokerLeadSend = 'broker-lead-send',
  brokerClick = 'broker-click',
  userPage = 'user-page',
  userSignIn = 'user-signin',
  userSignOut = 'user-signout',
  userRegister = 'user-register',
  managerClick = 'manager-click',
  ctaClick = 'cta-click',
  errorPage = 'error-page',
  myAccountPage = 'my-account',
  buyVsRentCalculatorPage = 'buyvsrent-calculator',
  propertyReadmoreClick = 'read-more',
  propertyLeadClickWhatsapp = 'property-lead-click-whatsapp',
  propertyLeadSendWhatsapp = 'property-lead-send-whatsapp',
  mortgageFinderWidgetImpression = 'mortgage-finder-widget-impression',
}
